import { ICreateViewDto, ViewDto } from "@ryde/shared";

import { IDashboardCard } from "../dynamic-dashboard.models";

/**
 * The dashboard's slice of a view's free-form `viewState` jsonb. The backend
 * stores `viewState` as unvalidated jsonb, so a card layout rides alongside the
 * grid fields the type declares — we read/write it through this shape.
 */
interface IDashboardViewState {
  dashboardConfig?: { cards: IDashboardCard[] };
}

export const cloneCards = (cards: IDashboardCard[]): IDashboardCard[] =>
  cards.map(card => ({ ...card }));

export const readViewCards = (
  view: ViewDto | undefined,
): IDashboardCard[] | undefined =>
  (view?.viewState as IDashboardViewState | undefined)?.dashboardConfig?.cards;

/**
 * The view marked default, if any. Derived in one place because two callers must agree on it: the
 * panel that auto-applies it, and the gate that waits for that to have happened.
 */
export const findDefaultView = (views: ViewDto[]): ViewDto | undefined =>
  views.find(view => view.isDefault);

/** Pack the current card layout into a `viewState` payload (cast — see IDashboardViewState). */
export const toViewState = (
  cards: IDashboardCard[],
): ICreateViewDto["viewState"] =>
  ({
    dashboardConfig: { cards: cloneCards(cards) },
  }) as unknown as ICreateViewDto["viewState"];
